export const acceptedFiles = [
    '.pdf',
    '.doc',
    '.docx',
    '.xls',
    '.xlsx',
    '.rtf',
    '.txt',
    '.jpg',
    '.jpeg',
    '.tiff',
    '.tif',
];
